import { CourseSale, OnSaleCourseDetails } from '@yi/core/src/course-sale';

import { useFeatureFlag } from '~/src/components/hooks/useFeatureFlag';

export const useCourseSale = (courseDetails: OnSaleCourseDetails) => {
  const courseSale = new CourseSale(courseDetails);
  /**
   * if promo sale is started, you need to "start" sale, by running
   *  `courseSale.start();`
   * it's needed to be able to hide sale behind the feature flag
   * */
  const blackFridaySaleFeatureFlag = useFeatureFlag('black_friday');
  if (blackFridaySaleFeatureFlag.enabled) {
    courseSale.start();
  } else {
    courseSale.stop();
  }
  return courseSale;
};
